import {
  IntegrationConnectionHealthStatus,
  IntegrationConnectionStatus,
  IntegrationErrorCode,
  type IntegrationConnection,
} from 'src/api/generated';
import type { MeliIntegrationRecovery } from '../types/meli-integration-recovery.types';

const RECOVERY_ACTIONS: Partial<
  Record<IntegrationErrorCode, MeliIntegrationRecovery>
> = {
  [IntegrationErrorCode.AUTHORIZATION_FAILED]: {
    messageKey: 'settings.integrations.meli.health.authorizationFailed',
    actionLabelKey: 'settings.integrations.meli.actions.reauthorize',
    action: 'reauthorize',
  },
  [IntegrationErrorCode.PERMISSION_DENIED]: {
    messageKey: 'settings.integrations.meli.health.permissionDenied',
    actionLabelKey: 'settings.integrations.meli.actions.retrySync',
    action: 'retry',
  },
};

const FAILED_HEALTH_STATUSES = new Set<IntegrationConnectionHealthStatus>([
  IntegrationConnectionHealthStatus.PAUSED,
  IntegrationConnectionHealthStatus.ERROR,
]);

/**
 * Selects recovery only for an active connection's structured failure state.
 * @param connection - Latest backend-generated connection contract.
 * @returns Applicable recovery, or null for healthy/disconnected/unrelated states.
 */
export function getMeliIntegrationRecovery(
  connection: IntegrationConnection | null
): MeliIntegrationRecovery | null {
  if (
    connection?.status !== IntegrationConnectionStatus.ACTIVE ||
    !connection.lastErrorCode ||
    !FAILED_HEALTH_STATUSES.has(connection.healthStatus)
  ) {
    return null;
  }
  return RECOVERY_ACTIONS[connection.lastErrorCode] ?? null;
}
